import React, { useEffect, useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import { searchGraph } from "../../services/MetadataService";
import { debounce } from "lodash";
import { CancelToken } from "axios";

const EntityAutocomplete = ({ onEntitySelected, context = {}, accept = undefined, input = {}, value, ...props }) => {
	const [options, setOptions] = useState(value != null ? [value] : [])
	const [searchTerm, setSearchTerm] = useState("")
	const [request, setRequest] = useState({})
	const updateSearchTerm = debounce(e => {
		const term = (e?.target?.value ?? "").trim().toLowerCase()
		setSearchTerm(term)
	}, 200)
	// const onSearchFieldChange = useMemo(e => updateSearchTerm(e), [updateSearchTerm])
	const onSearchFieldChange = updateSearchTerm
	useEffect(() => {
		
		if (request.cancel != null) {
			request.cancel()
		}
		
		const foundOptions = (response) => {
			const found = accept ? response.filter(e => accept.indexOf(e.context) >= 0) : response
			setOptions(found)
		}
		
		if (searchTerm.length < 1) {
			foundOptions([])
			return
		}
		
		if (request.searchTerm === searchTerm)
			return
		
		searchGraph(searchTerm, false, context.type, context.id, {
			cancelRequest: new CancelToken(cancel => {
				setRequest({ searchTerm, cancel })
			})
		}).then(foundOptions).catch((error) => {
			console.log(error) // TODO: we can do better than this...
		}).finally(() => {
			setRequest({ searchTerm, cancel: null })
		})
	}, [searchTerm, accept, context.id, context.type, request])

	return (
		<Autocomplete
				{...props}
				value={value}
				options={options}
				getOptionLabel={option => option.name}
				renderOption = { ({ context, name }) => (
					<div className="search-option">
						<div className="search-option-type">{context}</div>
						<div className="search-option-name">{name}</div>
					</div>
				)}
				getOptionSelected={(a, b) => (a.id === b.id && a.context === b.context)}
				renderInput={(params) => 
					<TextField {...params}
						{...input}
						variant="outlined"
						onChange={onSearchFieldChange} />
				}
				onChange = {(_, value) => {
					onEntitySelected(value)
				}
			}
		/>
	)
}

export default EntityAutocomplete;